/**
 * The segmented control that switches standings grouping (Scores UX spec
 * v1.0 section 10): the shared `SegmentedControl`, a solid `primary` pill on a
 * sunken track, never loose tabs. The selection lives in `?grouping=`, so a
 * shared link opens the same table and Back undoes a switch.
 *
 * Renders nothing at all for a league with one flat table (SCORES-17): the
 * caller never passes a one-option list, because `buildStandingsView`
 * already empties it.
 */
import { SegmentedControl } from "@sportsmet/ui";
import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import {
  STANDINGS_GROUPING_LABEL,
  type typeStandingsGroupingOption,
} from "./standingsTypes";

export const StandingsGroupingControl = ({
  options,
  selectedKey,
}: {
  options: typeStandingsGroupingOption[];
  selectedKey: string;
}): ReactNode => {
  // No `from`: the throwaway single-route router `renderInShell` uses in
  // tests is not `/scores` (same reason as `GameDetailScreen.tsx`).
  const navigate = useNavigate();
  if (options.length === 0) return null;

  return (
    <SegmentedControl
      label={STANDINGS_GROUPING_LABEL}
      testId="standings-grouping"
      options={options.map((option) => ({
        value: option.key,
        label: option.label,
      }))}
      value={selectedKey}
      onValueChange={(next) => {
        void navigate({
          to: ".",
          search: (prev: unknown) => ({
            ...(prev as Record<string, unknown>),
            grouping: next,
          }),
        });
      }}
    />
  );
};
